// Added by Sejune Oh on 2020-04-17
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    Switch as MaterialSwitch,
    SwitchProps as MaterialSwitchProps
} from '@material-ui/core'

// Common props
interface SwitchBaseProps { }
export type SwitchProps = Partial<MaterialSwitchProps> & SwitchBaseProps

export const Switch: FC<SwitchProps> = ({ ...props }) => {
    return <MaterialSwitch  {...props} />
}
